import blog1Asset__url from "@/assets/tavi-cover.jpg";
const blog1Asset = { url: blog1Asset__url };
const blog1 = blog1Asset.url;
import blog2Asset__url from "@/assets/aneurisma-cover.jpg";
const blog2Asset = { url: blog2Asset__url };
const blog2 = blog2Asset.url;
import blog3Asset__url from "@/assets/revascularizacao-cover.jpg";
const blog3Asset = { url: blog3Asset__url };
const blog3 = blog3Asset.url;

export type ContentBlock =
  | { type: "p"; text: string }
  | { type: "h"; text: string }
  | { type: "list"; items: string[] }
  | { type: "note"; text: string }
  | { type: "image" };

export type BlogPost = {
  slug: string;
  category: string;
  title: string;
  excerpt: string;
  metaDescription: string;
  image: string;
  content: ContentBlock[];
};

export const blogPosts: BlogPost[] = [
  {
    slug: "tavi-quando-esse-procedimento-pode-ser-indicado",
    category: "TAVI",
    title: "TAVI: quando esse procedimento pode ser indicado?",
    excerpt:
      "Entenda de forma simples o que é o implante valvar aórtico transcateter e em quais casos ele pode ser avaliado.",
    metaDescription:
      "Entenda de forma educativa o que é o TAVI, quando pode ser avaliado e por que a decisão deve ser individualizada com orientação médica especializada.",
    image: blog1,
    content: [
      {
        type: "p",
        text: "O TAVI (Implante Valvar Aórtico Transcateter) é um procedimento minimamente invasivo utilizado no tratamento da estenose da válvula aórtica em pacientes selecionados. Trata-se de uma alternativa à cirurgia convencional em situações específicas, definidas de forma individualizada.",
      },
      { type: "h", text: "O que é a estenose aórtica?" },
      {
        type: "p",
        text: "A estenose aórtica é o estreitamento da válvula aórtica, que dificulta a passagem do sangue do coração para o restante do corpo. Com o tempo, isso pode sobrecarregar o coração e levar ao surgimento de sintomas.",
      },
      { type: "h", text: "Quando o TAVI pode ser avaliado?" },
      {
        type: "p",
        text: "A indicação depende de uma avaliação cuidadosa, que considera o quadro clínico, os exames de imagem e o perfil de risco de cada paciente. De forma geral, o procedimento pode ser discutido em situações como:",
      },
      {
        type: "list",
        items: [
          "Estenose aórtica importante confirmada em exames.",
          "Pacientes com maior risco para cirurgia convencional.",
          "Casos em que a equipe médica avalia benefício de uma abordagem menos invasiva.",
        ],
      },
      { type: "image" },
      { type: "h", text: "Como é definida a indicação?" },
      {
        type: "p",
        text: "A indicação entre TAVI e cirurgia convencional é individualizada e deve ser avaliada pelo Heart Team, um time de especialistas que analisa cada caso com base em evidências, condições clínicas e exames complementares do paciente.",
      },
      {
        type: "p",
        text: "Existem critérios específicos para indicar TAVI, considerando fatores como risco cirúrgico, anatomia da válvula, idade, histórico de saúde e características de cada caso.",
      },
      {
        type: "p",
        text: "O paciente e sua família recebem orientação clara sobre as possibilidades, riscos e próximos passos, mas a indicação do procedimento depende de avaliação médica especializada.",
      },
      {
        type: "note",
        text: "Este conteúdo é informativo e não substitui avaliação médica individualizada.",
      },
    ],
  },
  {
    slug: "valvulopatias-quando-investigar-alteracoes-nas-valvulas-do-coracao",
    category: "Valvulopatias",
    title: "Valvulopatias: quando investigar alterações nas válvulas do coração?",
    excerpt:
      "Falta de ar aos esforços, inchaço nas pernas e sopro na ausculta podem indicar a necessidade de avaliação especializada.",
    metaDescription:
      "Entenda sinais que podem estar relacionados às valvulopatias, como falta de ar aos esforços, edema em membros inferiores e sopro na ausculta cardíaca.",
    image: blog2,
    content: [
      {
        type: "p",
        text: "As válvulas do coração funcionam como portas que ajudam o sangue a seguir o fluxo correto dentro do coração.",
      },
      {
        type: "p",
        text: "Quando uma dessas válvulas apresenta estreitamento, insuficiência ou alteração no seu funcionamento, chamamos esse quadro de valvulopatia.",
      },
      {
        type: "p",
        text: "Em alguns casos, as valvulopatias evoluem de forma silenciosa. Em outros, podem causar sintomas que merecem atenção e avaliação especializada.",
      },
      { type: "h", text: "O que são valvulopatias?" },
      {
        type: "p",
        text: "Valvulopatias são doenças que acometem as válvulas cardíacas.",
      },
      {
        type: "p",
        text: "Elas podem dificultar a passagem do sangue ou permitir que parte do sangue retorne no sentido contrário ao esperado.",
      },
      {
        type: "p",
        text: "As válvulas mais frequentemente avaliadas são a aórtica, mitral, tricúspide e pulmonar.",
      },
      { type: "h", text: "Sintomas que merecem atenção" },
      {
        type: "p",
        text: "Alguns sinais podem indicar que uma valvulopatia precisa ser investigada, especialmente quando surgem ou pioram com o tempo.",
      },
      {
        type: "p",
        text: "Entre eles:",
      },
      {
        type: "list",
        items: [
          "falta de ar aos esforços;",
          "cansaço fora do habitual;",
          "edema ou inchaço em membros inferiores;",
          "sensação de palpitações;",
          "dor ou desconforto no peito;",
          "tontura ou desmaios em alguns casos;",
          "sopro percebido durante a ausculta do coração.",
        ],
      },
      {
        type: "p",
        text: "A presença desses sintomas não significa, necessariamente, que o paciente tem uma doença valvar grave. Mas indica que uma avaliação médica pode ser importante.",
      },
      { type: "image" },
      { type: "h", text: "Falta de ar aos esforços" },
      {
        type: "p",
        text: "A falta de ar durante atividades que antes eram bem toleradas pode ser um sinal de que o coração está trabalhando com maior dificuldade.",
      },
      {
        type: "p",
        text: "Em casos de valvulopatias, esse sintoma pode aparecer de forma progressiva, primeiro em esforços maiores e, depois, em atividades simples do dia a dia.",
      },
      { type: "h", text: "Edema de membros inferiores" },
      {
        type: "p",
        text: "O inchaço nas pernas, tornozelos ou pés pode estar relacionado a diferentes causas.",
      },
      {
        type: "p",
        text: "Quando associado a cansaço, falta de ar, palpitações ou histórico de doença cardíaca, deve ser avaliado com atenção.",
      },
      { type: "h", text: "Sopro na ausculta do coração" },
      {
        type: "p",
        text: "O sopro é um som percebido pelo médico durante a ausculta do coração.",
      },
      {
        type: "p",
        text: "Nem todo sopro indica uma doença grave, mas ele pode ser um sinal de alteração no fluxo do sangue pelas válvulas cardíacas.",
      },
      {
        type: "p",
        text: "Quando identificado, o médico pode solicitar exames complementares, como o ecocardiograma, para entender melhor o funcionamento das válvulas.",
      },
      { type: "h", text: "Como é feita a avaliação?" },
      {
        type: "p",
        text: "A avaliação começa com a história clínica, exame físico e análise dos sintomas.",
      },
      {
        type: "p",
        text: "Quando há suspeita de valvulopatia, exames como ecocardiograma, eletrocardiograma, exames laboratoriais e outros exames complementares podem ser solicitados conforme cada caso.",
      },
      {
        type: "p",
        text: "A partir dessas informações, é possível definir se o paciente precisa apenas de acompanhamento, tratamento clínico, procedimento percutâneo ou cirurgia.",
      },
      { type: "h", text: "Quando procurar avaliação?" },
      {
        type: "p",
        text: "Procure avaliação médica se você apresenta falta de ar aos esforços, inchaço nas pernas, cansaço progressivo, palpitações ou se recebeu a informação de que tem um sopro no coração.",
      },
      {
        type: "p",
        text: "Quanto mais individualizada for a avaliação, mais segura tende a ser a definição dos próximos passos.",
      },
      {
        type: "note",
        text: "Este conteúdo é informativo e não substitui avaliação médica individualizada.",
      },
    ],
  },
  {
    slug: "cirurgia-de-revascularizacao",
    category: "Revascularização",
    title: "Cirurgia de revascularização: o que o paciente precisa saber",
    excerpt: "Veja como funciona a avaliação para casos de obstruções nas artérias do coração.",
    metaDescription:
      "Entenda de forma educativa como funciona a avaliação para a cirurgia de revascularização do miocárdio e por que cada caso é individualizado.",
    image: blog3,
    content: [
      {
        type: "p",
        text: "A cirurgia de revascularização do miocárdio é indicada em casos de obstruções importantes nas artérias do coração. O objetivo é restabelecer o fluxo sanguíneo e reduzir riscos, sempre a partir de uma avaliação individualizada.",
      },
      { type: "h", text: "O que são as obstruções coronárias?" },
      {
        type: "p",
        text: "As artérias coronárias levam sangue para o músculo cardíaco. Quando há estreitamento ou obstrução, parte do coração pode receber menos sangue do que necessita, o que precisa ser avaliado com atenção.",
      },
      { type: "h", text: "Como funciona a avaliação?" },
      {
        type: "list",
        items: [
          "Análise da história clínica e dos sintomas.",
          "Revisão de exames de imagem e laudos anteriores.",
          "Discussão individualizada das possibilidades de tratamento.",
        ],
      },
      { type: "image" },
      { type: "h", text: "A decisão é sempre individualizada" },
      {
        type: "p",
        text: "Nem todos os casos têm a mesma conduta. A indicação cirúrgica é definida considerando o conjunto de informações de cada paciente, com orientação clara, técnica e humanizada.",
      },
      {
        type: "note",
        text: "Este conteúdo é informativo e não substitui avaliação médica individualizada.",
      },
    ],
  },
];

export function getPostBySlug(slug: string): BlogPost | undefined {
  return blogPosts.find((p) => p.slug === slug);
}
